var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5449 1.54317C29.3343 0.705955 30.6657 0.705956 31.4551 1.54317L36.4989 6.89215C36.9666 7.38817 37.6548 7.61177 38.3247 7.4854L45.5493 6.12264C46.6801 5.90935 47.7572 6.69189 47.9037 7.83324L48.8402 15.1253C48.927 15.8015 49.3523 16.3869 49.9686 16.6785L56.6144 19.8225C57.6546 20.3145 58.066 21.5807 57.5137 22.5903L53.9851 29.0401C53.6579 29.6382 53.6579 30.3618 53.9851 30.9599L57.5137 37.4097C58.066 38.4193 57.6546 39.6855 56.6144 40.1775L49.9686 43.3215C49.3523 43.6131 48.927 44.1985 48.8402 44.8747L47.9037 52.1668C47.7572 53.3081 46.6801 54.0907 45.5493 53.8774L38.3247 52.5146C37.6548 52.3882 36.9666 52.6118 36.4989 53.1078L31.4551 58.4568C30.6657 59.294 29.3343 59.294 28.5449 58.4568L23.5011 53.1078C23.0334 52.6118 22.3452 52.3882 21.6753 52.5146L14.4507 53.8774C13.3199 54.0907 12.2428 53.3081 12.0963 52.1668L11.1598 44.8747C11.073 44.1985 10.6477 43.6131 10.0314 43.3215L3.3856 40.1775C2.34541 39.6855 1.934 38.4193 2.48629 37.4097L6.01486 30.9599C6.34207 30.3618 6.34207 29.6382 6.01486 29.0401L2.48629 22.5903C1.934 21.5807 2.34541 20.3145 3.3856 19.8225L10.0314 16.6785C10.6477 16.3869 11.073 15.8015 11.1598 15.1253L12.0963 7.83324C12.2428 6.6919 13.3199 5.90935 14.4507 6.12264L21.6753 7.4854C22.3452 7.61177 23.0334 7.38817 23.5011 6.89215L28.5449 1.54317Z",
    fill: "url(#paint0_linear_19_1264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 30.1765L28.8372 38L40 24",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_1264",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0048FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002B99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_1264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.50a9d7be4dc09063fbc0b91591909aa7.svg";
export { ForwardRef as ReactComponent };